
<div class="container container-extra main-container">

  <h1 class="page-title">{{ 'PRIVACY_POLICY_COMPONENT.TITLE' | translate }}</h1>

    <!-- Egy privacy polocy page, mat-card -ban Title, egy link a letölthető policy-re és egy checkbox alatta amiben benne van két mondat. A card footerben pedig egy Tovább gomb -->
    <mat-card class="card-light card-privacy-policy">
      <mat-card-content>
        <mat-checkbox [(ngModel)]="accepted">
          {{ 'PRIVACY_POLICY_COMPONENT.CONSENT_TEXT_PART1' | translate }} <a rel="privacy-policy" href="/assets/doc/hu/adatkezelesi-tajekoztato-hu.pdf" target="_blank">{{ 'PRIVACY_POLICY_COMPONENT.CONSENT_TEXT_LINK' | translate }}</a> {{ 'PRIVACY_POLICY_COMPONENT.CONSENT_TEXT_PART2' | translate }}
        </mat-checkbox>
      </mat-card-content>
      <div class="gradient-separator"></div>
      <mat-card-actions>
        <button mat-flat-button color="primary button-next" (click)="next()" [disabled]="!accepted">{{ 'PRIVACY_POLICY_COMPONENT.NEXT_BUTTON' | translate }}</button>
      </mat-card-actions>
    </mat-card>


</div>
